import { useDispatch } from "react-redux";

import { setSection, updateSection } from "../../../assignmentSlice";

import { useTTS } from "../../../../../hooks/useTTS";
import { typeInfo } from "../../../../../constants/typeInfo";

const ChoiceExamPage = ({
  section,
  pageList,
  currentPage,
  currentIndex,
  setCurrentIndex,
  setPageList,
  setOverlayVisible,
  setOverlayResult,
  isPreview = false,
  isReview = false,
}) => {
  const dispatch = useDispatch();
  const { speak, stopSpeaking } = useTTS();

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const selectOption = async ({ optionIndex }) => {
    const realIndex = optionIndex + 1;
    const isCorrect = realIndex === currentPage.answer;
    const newPageList = pageList.map((page, index) => {
      if (index === currentIndex) {
        return {
          ...page,
          isCorrect,
          input: realIndex,
          isSubmitted: true,
        };
      }
      return page;
    });
    setPageList(newPageList);
    dispatch(setSection({ ...section, answer: newPageList }));
    stopSpeaking();
    const speakPromise = speak({ text: currentPage.word });
    if (!isPreview && !isReview) {
      const isFinished =
        newPageList.length > 0 &&
        !newPageList.some((page) => page.isSubmitted === false);
      dispatch(
        updateSection({
          sectionId: section.id,
          data: { answer: newPageList, is_finished: isFinished },
        })
      );
    }
    setOverlayResult(isCorrect);
    setOverlayVisible(true);
    await delay(600);
    setOverlayVisible(false);

    if (isCorrect && currentIndex + 1 < pageList.length) {
      await speakPromise;
      setCurrentIndex(currentIndex + 1);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        // [사이즈 수술] 75vw 고정이 공용틀 안에서 어긋나 좌우 잘림 —
        // 전폭 + 640 상한 + border-box로 고정. 톤·로직 무변경.
        width: "100%",
        maxWidth: "640px",
        margin: "0 auto",
        boxSizing: "border-box",
        padding: Math.min(window.innerWidth, window.screen.width) <= 768 ? "0 6px" : 0,
        gap: "30px",
      }}
    >
      <div
        style={{
          fontSize: Math.min(window.innerWidth, window.screen.width) <= 768 ? "14px" : "20px",
          textAlign: "center",
          color: "#737373",
        }}
      >
        {currentPage.question}
      </div>
      {currentPage.type === "example_blank_choice" && (
        <div
          style={{
            fontSize: Math.min(window.innerWidth, window.screen.width) <= 768 ? "20px" : "28px",
            textAlign: "center",
          }}
        >
          {currentPage.text1}
        </div>
      )}
      <div
        style={{
          fontSize: Math.min(window.innerWidth, window.screen.width) <= 768 ? "20px" : "28px",
          textAlign: "center",
        }}
      >
        {currentPage.text}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "14px",
        }}
      >
        {currentPage.choices.map((option, optionIndex) => {
          return (
            <div
              style={{
                textAlign: "center",
                padding: "16px 20px",
                border: "1px solid #EBEBEB",
                borderRadius: "5px",
                fontWeight:
                  currentPage.isSubmitted &&
                  (optionIndex + 1 === currentPage.answer ||
                    optionIndex + 1 === currentPage.input)
                    ? "bold"
                    : "normal",
                cursor: !currentPage.isSubmitted && "pointer",
                backgroundColor:
                  currentPage.isSubmitted &&
                  currentPage.answer === optionIndex + 1
                    ? typeInfo["vocabulary"].backgroundColor
                    : currentPage.input === optionIndex + 1 &&
                      "rgba(240, 52, 52, 0.5)",
                color:
                  currentPage.isSubmitted &&
                  currentPage.answer === optionIndex + 1
                    ? typeInfo["vocabulary"].color
                    : currentPage.input === optionIndex + 1 && "white",
                fontSize: Math.min(window.innerWidth, window.screen.width) <= 768 ? "15px" : "18px",
              }}
              onClick={() => {
                if (currentPage.isSubmitted) return;
                selectOption({ optionIndex });
              }}
            >
              {option}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ChoiceExamPage;
